{
  "spinner": {
    "status": "Йде пошук варіантів..."
  },
  "buttons": {
    "delete": "Видалити",
    "done": "Готово",
    "next": "Далі",
    "continue": "Продовжити",
    "back": "Назад",
    "send": "Надіслати",
    "choose": "Вибрати",
    "apply": "Оформити",
    "sendFeedback": "Надіслати відгук",
    "clearThanks": "Дякую, все зрозуміло",
    "sendRequest": "Надіслати запит",
    "save": "Зберегти",
    "review": "Переглянути",
    "change": "Змінити",
    "cancel": "Відміна",
    "reject": "Відхилити",
    "approve": "Схвалити",
    "confirm": "Підтвердити",
    "view": "Переглянути",
    "download": "Завантажити",
    "upload": "Завантажити",
    "copyOrder": "Копіювати замовлення",
    "createOrder": "Створити замовлення",
    "edit": "Редагувати"
  },
  "navbar": {
    "sidebar": {
      "linkTitels": {
        "createOrder": "Створити",
        "myOrders": "Мої замовлення",
        "mySuggestions": "Мої пропозиції",
        "addressBook": "Адресна книга",
        "profile": "Профіль",
        "support": "Підтримка",
        "toggleMenu": "Згорнути меню",
        "uploadingFiles": "Завантаження файлів",
        "exchangeRates": "Курси валют",
        "notifications": "Сповіщення",
        "adminPanel": "Адмін панель",
        "registerUser": "Реєстрація користувача",
        "more": "Ще"
      }
    },
    "topNavBar": {
      "user": "Профіль користувача",
      "authUser": {
        "registeredAs": "Зареєстровано як",
        "account": "Обліковий запис",
        "help": "Допомога",
        "signOut": "Вихід"
      },
      "notAuthUser": {
        "authorization": "Авторизація",
        "registration": "Реєстрація"
      }
    }
  },
  "elements": {
    "search": "Пошук",
    "cost": "Вартість",
    "costTotal": "Вартість всього",
    "total": "Всього",
    "noData": "Немає даних",
    "byRequest": "По запиту"
  },
  "notFound": {
    "title": "Сторінка не знайдена"
  },
  "notSelected": {
    "title": "Не вибрано"
  },
  "measurementUnits": {
    "cm": "см",
    "kg": "кг",
    "m": "м",
    "ldm": "п.м.",
    "unit_one": "{{count}} одиниця",
    "unit_many": "{{count}} одиницi",
    "unit_few": "{{count}} одиницi"
  },
  "dimensions": {
    "quantity": "Кількість",
    "length": "Довжина*",
    "width": "Ширина*",
    "height": "Висота*",
    "weight": "Вага*",
    "totalNumber": "Загальна кількість",
    "volume": "Об'єм",
    "totalWeight": "Загальна вага",
    "bulkWeight": "Об'ємна вага",
    "ldmWeight": "LDM вага"
  },
  "contactInfo": {
    "contactPersonLbl": "Контактна особа",
    "noteLbl": "Примітка",
    "eMail": "E-mail",
    "additionally": "Additionally",
    "payer": "Платник",
    "selectPayer": "Вибрати платника",
    "vatId": "VAT ID",
    "edrpou": "ЄДРПОУ"
  },
  "dateTime": {
    "untilTime": "до {{time}}",
    "afterTime": "після {{time}}",
    "nonWorking": "неробочі дні"
  },
  "alerts": {
    "WrongMaxWeight": "Неправильна максимальна вага",
    "WrongCargoSize": "Неправильний розмір вантажу"
  },
  "tables": {
    "numberOfRows": "Кількість рядків",
    "totalResults": "{{min}}-{{max}} із {{totalCount}}",
    "noData": "Немає даних"
  },
  "companyStatuses": {
    "underReview": "На перевірці",
    "verified": "Перевірено"
  },
  "exchangeRates": {
    "title": "Курси валют",
    "refresh": "Оновити",
    "rateDate": "Дата курсу",
    "currency": "Валюта",
    "rate": "Курс",
    "source": "Джерело",
    "lastModified": "Останнє оновлення",
    "actions": "Дії",
    "manual": "Ручний",
    "editRate": "Редагувати курс валюти",
    "editHint": "Введіть нове значення курсу",
    "resetToAuto": "Скинути до авто",
    "error": "Не вдалося завантажити курси валют"
  },
  "footer": {
    "copyright": "© {{year}} Vega",
    "developedBy": "Розробка",
    "company": "Компанія",
    "apiIntegrations": "API та інтеграції",
    "privacyPolicy": "Політика конфіденційності",
    "termsConditions": "Умови використання",
    "news": "Новини"
  }
}